import {isNilOrEmpty} from 'ramda-adjunct';

import {MazdaWarrantyCode} from '@dms/api/workshop';

const CODE_DESCRIPTION_SEPARATOR = ' - ';

type MazdaCodeDescriptionEntry = Pick<MazdaWarrantyCode, 'description'> & {code: string};

export const getMazdaCodeDescriptionLabel = ({code, description}: MazdaCodeDescriptionEntry) => {
  const text = description?.trim();

  return isNilOrEmpty(text) || text === code ? code : `${code}${CODE_DESCRIPTION_SEPARATOR}${text}`;
};
